<template>
  <div class="block-wrapper" :key="currentInbox">
    <loading
      :active.sync="isLoading"
      :can-cancel="true"
      :is-full-page="false"
    ></loading>
    <div
      class="block"
      data-aos="slide-up"
      v-for="demo in currentInbox"
      :key="demo.id"
    >
      <div class="block--content">
        <div class="container">
          <div class="row">
            <div class="col-lg-2 content--center">
              <div class="block--content-item">
                <div>
                  <div class="demo--track-title">{{ demo.track_name }}</div>
                  <div class="demo--artist-name">{{ demo.artist_name }}</div>
                </div>
              </div>
            </div>
            <div class="col-lg-2 content--center">
              <div class="block--content-item">
                <SourceLabel :source="demo.page_name" />
              </div>
            </div>
            <div class="col-lg-3 content--center">
              <div class="block--content-item content--center page--link">
                <div class="page--url">
                  <a :href="'mailto:' + demo.artist_email" target="_blank">
                    {{ demo.artist_email
                    }}<svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      height="11px"
                      stroke="currentColor"
                      stroke-width="2.5"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      class="feather feather-external-link"
                    >
                      <path
                        d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6"
                      ></path>
                      <polyline points="15 3 21 3 21 9"></polyline>
                      <line x1="10" y1="14" x2="21" y2="3"></line>
                    </svg>
                    </a>
                </div>
              </div>
            </div>
            <div class="col-lg-3 content--center">
              <div class="block--content-item content--center">
                <span v-if="getDemoDate(demo.created_at) == 'Today'"><strong>{{ getDemoDate(demo.created_at) }}</strong></span>
                <span v-else>{{ getDemoDate(demo.created_at) }}</span>
              </div>
            </div>
            <div class="col-lg-1 content--center">
              <div
                class="block--content-item content--center"
                v-if="inbox == 'inbox'"
              >
                <div class="demo--accept" @click="approve(demo)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M9 21.035l-9-8.638 2.791-2.87 6.156 5.874 12.21-12.436 2.843 2.817z"
                    />
                  </svg>
                </div>
                <div class="demo--decline" @click="decline(demo)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path
                      d="M23.954 21.03l-9.184-9.095 9.092-9.174-2.832-2.807-9.09 9.179-9.176-9.088-2.81 2.81 9.186 9.105-9.095 9.184 2.81 2.81 9.112-9.192 9.18 9.1z"
                    />
                  </svg>
                </div>

                <div class="demo--options" @click="options(demo)">
                    <div class="demo--options-menu">
                     <router-link
                     class-active="navigation--top-link-active"
                     class="navigation--top-link text--small"
                     :to="{ name: 'DemoDetail', params: { id: demo.id } }"
                   >
                     <div class="">Share demo</div>
                   </router-link>
                     
                    <router-link
                    class-active="navigation--top-link-active"
                    class="navigation--top-link text--small"
                    :to="{ name: 'DemoDetail', params: { id: demo.id } }"
                  >
                    <div class="">Demo Details</div>
                  </router-link>
                    </div>
                    <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg"           width="20"
                    height="20" viewBox="0 0 408 408" style="enable-background:new 0 0 408 408;" xml:space="preserve">
                  <g>
                    <g id="more-vert">
                      <path d="M204,102c28.05,0,51-22.95,51-51S232.05,0,204,0s-51,22.95-51,51S175.95,102,204,102z M204,153c-28.05,0-51,22.95-51,51
                        s22.95,51,51,51s51-22.95,51-51S232.05,153,204,153z M204,306c-28.05,0-51,22.95-51,51s22.95,51,51,51s51-22.95,51-51
                        S232.05,306,204,306z"/>
                    </g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>                 <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  <g>
                  </g>
                  </svg>
                </div>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-lg-12 content--center">
              <div class="block--content-item player--audio"  style="width: 100%">
                <div class="demo--player" style="width: 100%">
                  <NativePlayer v-if="demo.demo_url != 'https://demobottle-storage.s3.eu-west-2.amazonaws.com/'" autoplay="false" :file="demo.demo_url"></NativePlayer>
                  
                  <a style="text-decoration: none;" :href="demo.soundcloud_url" target="_blank"><div class="demo--soundcloud" v-if="demo.soundcloud_url != null"><svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" 
                   viewBox="0 0 512 512" width="20" fill="white" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                <g>
                  <g>
                    <path d="M432,240c-5.696,0-11.296,0.608-16.672,1.76C408.128,169.024,346.592,112,272,112c-8.832,0-16,7.168-16,16v256
                      c0,8.832,7.168,16,16,16h160c44.128,0,80-35.872,80-80C512,275.904,476.128,240,432,240z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M208,144c-8.832,0-16,7.168-16,16v224c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16V160
                      C224,151.168,216.832,144,208,144z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M144,208c-8.832,0-16,7.168-16,16v160c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16V224
                      C160,215.168,152.832,208,144,208z"/>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M80,208c-8.832,0-16,7.168-16,16v160c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16V224C96,215.168,88.832,208,80,208z"
                      />
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M16,256c-8.832,0-16,7.168-16,16v96c0,8.832,7.168,16,16,16c8.832,0,16-7.168,16-16v-96C32,263.168,24.832,256,16,256z"/>
                  </g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                </svg>
                 Play on Soundcloud</div></a>
                  <a style="text-decoration: none;" :href="demo.dropbox_url" target="_blank"><div class="demo--dropbox" v-if="demo.dropbox_url != null"><svg version="1.1" width="20" fill="white" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
                   viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
                <g>
                  <g>
                    <polygon points="361.376,0 256,88.672 407.872,183.168 512,99.136 		"/>
                  </g>
                </g>
                <g>
                  <g>
                    <polygon points="150.624,0 0,99.104 104.16,183.168 256,88.672 		"/>
                  </g>
                </g>
                <g>
                  <g>
                    <g>
                      <polygon points="0,267.232 150.624,366.368 256,277.696 104.128,183.168 			"/>
                      <polygon points="407.84,183.168 256,277.696 361.376,366.368 512,267.232 			"/>
                    </g>
                  </g>
                </g>
                <g>
                  <g>
                    <path d="M368.992,399.648c-2.656,1.76-5.728,2.624-8.768,2.624c-3.68,0-7.328-1.28-10.304-3.744L256,319.488l-93.92,79.04
                      c-5.408,4.544-13.184,4.992-19.104,1.12L96,368.736V416l160.32,96L416,416v-47.296L368.992,399.648z"/>
                  </g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                <g>
                </g>
                </svg>
                
                
                   Play on Dropbox</div></a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import SourceLabel from "./SourceLabel";
import NativePlayer from "./NativePlayer";
import axios from "axios";

export default {
  name: "DemoLoader",
  components: {
    Loading,
    SourceLabel,
    NativePlayer
  },
  data() {
    return {
      demos: this.$globals.demos,
      isLoading: false,
    
    };
  },
  methods: {
    getDemoDate(timestamp) {
      return this.timeConverter(timestamp);
    },
    approve(demo) {
      let self = this;
      axios
        .patch("/demo/" + demo.id + "?status=approved", {})
        .then((res) => {
          self.$globals.getDemos();
          console.log(res);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    decline(demo) {
      let self = this;
      axios
        .patch("/demo/" + demo.id + "?status=removed", {})
        .then((res) => {
          self.$globals.getDemos();
          console.log(res);
        })
        .catch((error) => {
          console.error(error);
        });
    },
    timeConverter(UNIX_timestamp) {
      var a = new Date(UNIX_timestamp * 1000);
      if (!this.isToday(a)) {
        var months = [
          "January",
          "February",
          "March",
          "April",
          "May",
          "June",
          "July",
          "August",
          "September",
          "October",
          "November",
          "December",
        ];
        var year = a.getFullYear();
        var month = months[a.getMonth()];
        var date = a.getDate();
        var time = date + " " + month + " " + year + " ";
        return time;
      } else {
        return "Today";
      }
    },
    isToday(someDate) {
      const today = new Date();
      return (
        someDate.getDate() == today.getDate() &&
        someDate.getMonth() == today.getMonth() &&
        someDate.getFullYear() == today.getFullYear()
      );
    },
  },
  computed: {
    currentInbox() {
      console.log(this.inbox);
      if (this.inbox == "inbox") {
        return this.$globals.inbox;
      } else if (this.inbox == "approved") {
        return this.$globals.approved;
      } else if (this.inbox == "declined") {
        return this.$globals.declined;
      } else {
        return this.$globals.inbox;
      }
    },
  },
  props: {
    inbox: {
      type: String,
      required: true,
    },
  },
};
</script>
